import React from 'react'
import './LoadingSpinner.css'

const LoadingSpinner = ({ message = 'Cargando...' }) => {
  return (
    <div className='loading-spinner'>
      <div className='spinner' />
      <p className='loading-message'>{message}</p>
    </div>
  )
}

export default LoadingSpinner
